import { render } from "./Cell.vue?vue&type=template&id=87ecf392&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=87ecf392&lang=scss&scoped=true"

import exportComponent from "/Users/jenni/Documents/Labbet/lingobingo/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.73.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ecf392"]])

export default __exports__